import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ChartConfiguration, ChartData, ChartDataset } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { AnalyticsResultsService, DailySpendStatistic } from 'src/app/shared/services/analytics-results.service';

@Component({
  selector: 'app-spend-by-day-bar-chart',
  templateUrl: './spend-by-day-bar-chart.component.html',
  styleUrls: ['../widgets.scss', './spend-by-day-bar-chart.component.scss']
})
export class SpendByDayBarChartComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  constructor(private resultsAnalyticsSvc: AnalyticsResultsService, private breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      if (result.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }

      if (this.chartOptions && this.chartOptions.scales && this.chartOptions.scales["x"]) {
        this.chartOptions.scales["x"].display = (this.isMobile === false);
        this.chart?.render();
      }

      this.buildSpendByDayChartData();
    });
  }

  spendByDayData: DailySpendStatistic[] = new Array<DailySpendStatistic>();
  isMobile: boolean = false;

  chartPlugins = [];

  chartOptions: ChartConfiguration['options'] = {
    // We use these empty structures as placeholders for dynamic theming.
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 2,
    elements:{
      point: {
        hitRadius: 10
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        type: 'time',
        time: {
          tooltipFormat: 'D MMM yy'
        },
      },
      y: {
        beginAtZero: true,
        display: true,
        grid: {
          display: false
        },
        position: "right",
        ticks: {
          callback: (value, index, ticks) => {
            let v = value as number;
            if (v) {
              return '$' + v.toLocaleString();
            }
            return '$' + value;
          }
        }
      },
    },
    plugins: {
      legend: {
        display: false,
        // position: "bottom",
        labels: {
          boxWidth: 10
        }
      },
      tooltip: {
        callbacks: {
          label: (item) =>
            `$${item.formattedValue}` // `${item.dataset.label}: $${item.formattedValue}`
        }
      }
    },
  };

  chartData: ChartData<'bar', number[], Date> = {
    datasets: []
  };


  ngOnInit(): void {
    this.resultsAnalyticsSvc.getSpendByDayStatistics()
      .subscribe({
        next: (data) => {
          this.spendByDayData = data;
          this.buildSpendByDayChartData();
        },
        error: (err: HttpErrorResponse) => {
          if (err.status == 400) {
          } else {
            throw err;
          }
        }
      });
  }

  buildSpendByDayChartData(): void {
    if(!this.spendByDayData) {
      return;
    }

    let now = new Date(Date.now());
    let numOfMonths = this.isMobile === true ? -2 : -6;
    let startDate = this.addMonths(now, numOfMonths);
    let labels: Date[] = new Array<Date>();
    let data: number[] = new Array<number>();

    let processingChartData: ChartData<'bar', number[], Date> = {
      datasets: []
    }

    this.spendByDayData.forEach((x) => {
      let txnDate = new Date(x.dim_txndate_day_date);
      if(txnDate >= startDate) {
        labels.push(txnDate);
        data.push(x.fct_abs_spend as number);
      }
    });

    processingChartData.labels = labels;
    processingChartData.datasets.push({
      label: "Spend",
      barPercentage: 1.0,
      data: data
    });

    console.log(processingChartData);
    this.chartData = processingChartData;

    this.chart?.update();
  }

  addMonths(at: Date, months: number): Date {
    let d = new Date(at);
    d.setMonth(d.getMonth() + months);

    return d;
  }

}
